"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sections = require("./sections");

var _counter = _interopRequireDefault(require("../counter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CounterWidget = function CounterWidget(_ref) {
  var _backgroundImage$fiel, _backgroundImage$fiel2, _backgroundImage$fiel3, _backgroundImageMobil, _backgroundImageMobil2, _backgroundImageMobil3;

  var backgroundImage = _ref.backgroundImage,
      backgroundImageMobile = _ref.backgroundImageMobile,
      props = _objectWithoutProperties(_ref, ["backgroundImage", "backgroundImageMobile"]);

  var backgroundImageSrc = (_backgroundImage$fiel = backgroundImage === null || backgroundImage === void 0 ? void 0 : (_backgroundImage$fiel2 = backgroundImage.fields) === null || _backgroundImage$fiel2 === void 0 ? void 0 : (_backgroundImage$fiel3 = _backgroundImage$fiel2.file) === null || _backgroundImage$fiel3 === void 0 ? void 0 : _backgroundImage$fiel3.url) !== null && _backgroundImage$fiel !== void 0 ? _backgroundImage$fiel : null;
  var backgroundImageMobileSrc = (_backgroundImageMobil = backgroundImageMobile === null || backgroundImageMobile === void 0 ? void 0 : (_backgroundImageMobil2 = backgroundImageMobile.fields) === null || _backgroundImageMobil2 === void 0 ? void 0 : (_backgroundImageMobil3 = _backgroundImageMobil2.file) === null || _backgroundImageMobil3 === void 0 ? void 0 : _backgroundImageMobil3.url) !== null && _backgroundImageMobil !== void 0 ? _backgroundImageMobil : null;
  return /*#__PURE__*/_react["default"].createElement(_counter["default"], _extends({}, props, {
    backgroundImage: backgroundImageSrc,
    backgroundImageMobile: backgroundImageMobileSrc
  }));
};

CounterWidget.propTypes = {};
(0, _sections.registerWidget)('counter', CounterWidget);
var _default = CounterWidget;
exports["default"] = _default;